import { Modal } from "ant-design-vue";
import { createVNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import router from "@/router";
import FichaGeneralApi from "@/api/fichas/global";
import { typeformalization } from "@/utils/shared";
import { notification } from "ant-design-vue";

/**
 * generateModules
 * ===============
 * @param {Array} entrada
 * @returns {Array}
 */
export const generateModules = (entrada = []) => {
  if (!entrada.length) return [];

  return entrada.reduce((a, b) => {
    a.includes(b.modulo) ? a : a.push(b.modulo);

    return a;
  }, []);
};

export const functionGet = (info = [], buscar = "") => {
  if(info.data != undefined)
  {
    var dataInfo = info.data[0]?.docs[0];
    
    if (dataInfo != undefined && dataInfo != null) {
      var selected = 0;
      var columns = Object.keys(dataInfo);
      var values = Object.values(dataInfo);

      for (let index = 0; index < columns.length; index++) {
        const element = columns[index];

        if (element == buscar) {
          selected = index;
          break;
        }
      }

      return values[selected];
    }
  }
  
  return "";
};

export const existIdFicha2 = (idficha, objficha) => {
  // console.log(idficha);
  return new Promise((resolve, reject) => {
    if (idficha) return resolve(idficha);

    Modal.confirm({
      title: () => "Aún no has creado una ficha, ¿deseas crear una?, se pueden perder los cambios.",
      icon: () => createVNode(ExclamationCircleOutlined),
      okText: () => "Sí, crear",
      okType: "primary",
      cancelText: () => "Cancelar",

      onOk() {
        FichaGeneralApi.addOne(objficha.code)
          .then(async (res) => {
            console.log(res);
            const idficha = res.data[0]?.id;

            FichaGeneralApi.addOneTypeFicha(idficha, objficha.table).catch((err) =>
              console.log(err)
            );
            FichaGeneralApi.setNumeroFicha(idficha).catch((err) => console.log(err));

            router.push({ name: `${objficha.path}-editar`, params: { idficha } });
            resolve(idficha);

            if (idficha) {
              setTimeout(() => {
                router.go();
              }, 1000);
            }
          })
          .catch((err) => {
            console.log(err);
            router.push(`/${objficha.path}`);
            reject(err);
          });
      }
    });

    reject("");
  });
};

export function groupFichas(entrada = []) {
  if (!entrada.length) return [];

  return entrada.reduce((a, b) => {
    var i = a.findIndex((x) => x.idtipoficha === b.idtipoficha);

    const isFormal = b.idtipoformalizacion === typeformalization.formalizado;
    const isNoFormal = b.idtipoformalizacion === typeformalization.noformalizado;

    if (i === -1) {
      // si es nuevo
      a.push({
        idtipoficha: b.idtipoficha, // importante poner el id
        formal: isFormal ? Number(b.count) : 0,
        noformal: isNoFormal ? Number(b.count) : 0,
        suma: Number(b.count)
      });
    } else {
      // si se repite
      a[i].formal = isFormal ? a[i].formal + Number(b.count) : a[i].formal;
      a[i].noformal = isNoFormal ? a[i].noformal + Number(b.count) : a[i].noformal;
      a[i].suma = a[i].suma + Number(b.count);
    }

    return a;
  }, []);
}

export function sumDigitsOfNumber(number) {
  if (!number) return 0;

  return number
    .toString()
    .split("")
    .map(Number)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
}

export const changeFormalidad = (idficha, idtipoformalizacion) => {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: () =>
        "Deseas convertir en ficha " + (idtipoformalizacion === "1" ? "INFORMAL" : "FORMAL") + "?",
      icon: () => createVNode(ExclamationCircleOutlined),
      okText: () => "Sí, convertir",
      okType: "primary",
      cancelText: () => "Cancelar",

      onOk() {
        FichaGeneralApi.updateField({
          idficha,
          columna: "idtipoformalizacion",
          valor:
            idtipoformalizacion === "1"
              ? typeformalization.noformalizado
              : typeformalization.formalizado
        })
          .then(async (res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  });
};

export function modalCreateNewFicha(objficha, idtipoformalizacion) {
  const isPathFormalizado =
    Number(idtipoformalizacion) === 1 ? objficha.path : objficha.path + "-nf";

  Modal.confirm({
    title: () => "Deseas crear la ficha?",
    icon: () => createVNode(ExclamationCircleOutlined),
    okText: () => "Sí, crear",
    okType: "primary",
    cancelText: () => "No, cancelar",

    onOk() {
      FichaGeneralApi.addOne(objficha.code, idtipoformalizacion)
        .then(async (res) => {
          var idficha = res.data[0]?._id;

          FichaGeneralApi.addOneTypeFicha(idficha, objficha.table, objficha.code).catch((err) =>
            console.log(err)
          );

          if (objficha.numeration) {
            const res2 = await FichaGeneralApi.calculaMaxNumeroFicha(objficha.code);
            const maxNumeroFicha = Number(res2?.info?.max) + 1 || 1;

            FichaGeneralApi.setNumeroFicha(idficha, maxNumeroFicha).catch((err) =>
              console.log(err)
            );
          }

          const routeName = isPathFormalizado;
          router.push({ name: `${routeName}-editar`, params: { idficha } });
        })
        .catch((err) => {
          console.log(err);
          router.push(`/${objficha.path}`);
        });
    },
    onCancel() {
      router.push(`/${isPathFormalizado}`);
    }
  });
}

/**
 * shortName
 * ---------
 * Saca la primera palabra del nombre y apellido
 * ej. Jorge Alfredo Basadre Grohmann
 * retorna: Jorge Basadre
 * @param {String} nombres
 * @param {String} apellidos
 * @returns {String}
 */
export const shortName = (nombres = "", apellidos = "") => {
  if (!nombres || !apellidos) return "";

  return nombres.split(" ")[0] + " " + apellidos.split(" ")[0];
};

export const graphicFichas = (data = []) => {
  return {
    xAxis: {
      type: "category",
      data: ["Individual", "Económica", "Cotitular", "Rural", "Común", "Cultural"]
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data,
        type: "bar",
        smooth: true
      }
    ]
  };
};

export const graphicFichas2 = (data = []) => {
  return {
    xAxis: {
      type: "category",
      data: ["Formales", "Informales"]
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data,
        type: "bar",
        smooth: true
      }
    ]
  };
};

export const graphicDocumentos = (data = []) => {
  return {
    xAxis: {
      type: "category",
      data: ["C. Negativa", "C. Posesión", "Cert. Posesión", "Cert. Numeración", "Cert.Catastral"]
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data,
        type: "bar",
        smooth: true
      }
    ]
  };
};

export const graphicDocumentos2 = (data = []) => {
  return {
    xAxis: {
      type: "category",
      data: ["Constancias", "Certificados"]
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data,
        type: "bar",
        smooth: true
      }
    ]
  };
};

export const graphicSectores = (data = []) => {
  return {
    xAxis: {
      type: "category",
      data: data.map((p) => p.sector)
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data: data.map((p) => p.total),
        type: "bar",
        smooth: true
      }
    ]
  };
};

export function modalCreateNewFichaWithCodigo(objficha, idtipoformalizacion, idficha, payload) {
  Modal.confirm({
    title: () => "Deseas crear una nueva ficha o ver un borrador de esta?",
    icon: () => createVNode(ExclamationCircleOutlined),
    okText: () => "Sí, crear",
    okType: "primary",
    cancelText: () => "No, ver borrador",

    onOk() {
      FichaGeneralApi.getCodigoCatastralByFicha(idficha)
        .then(async (res) => {
          
          if(res.data[0].docs.length == 0) {
            notification.warning({
              message: "Operación inválida",
              description:
                "No se pudo crear, primero ingreso el sector, manzana lote."
            });

            return;
          }

          const idlote = res.data[0].docs[0].idlote;

          payload.idlote = idlote;

          FichaGeneralApi.addOne(objficha.code, idtipoformalizacion)
            .then(async (res) => {
              const idficha = res.data[0]?._id;

              var response = await FichaGeneralApi.addEditCodigoCatastral(payload, "");

              const idcodigounico = response.data[0]?._id;
              await FichaGeneralApi.asignCodUnicoAFicha(idficha, idcodigounico);

              FichaGeneralApi.addOneTypeFicha(idficha, objficha.table).catch((err) =>
                console.log(err)
              );
              FichaGeneralApi.setNumeroFicha(idficha).catch((err) => console.log(err));

              const routeName =
                Number(idtipoformalizacion) === 1 ? objficha.path : objficha.path + "-nf";

              router.push({ name: `${routeName}-editar`, params: { idficha } });

            })
            .catch((err) => {
              console.log(err);
              router.push(`/${objficha.path}`);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onCancel() {
      router.push(`/${objficha.path}/nuevo`);
    }
  });
}

export const calculaTotalAutorizacionMunicipal = (
  predioArea = 0,
  viaArea = 0,
  BienComunArea = 0
) => {
  return parseFloat(predioArea || 0) + parseFloat(viaArea || 0) + parseFloat(BienComunArea || 0);
};
